<script setup lang="ts">
const emit = defineEmits(['close'])
</script>

<template>
  <div class="modal-backdrop" @click.self="emit('close')">
    <div class="modal-window">
      <button class="close-btn" @click="emit('close')" aria-label="Zavřít">
        <svg
          viewBox="0 0 24 24"
          width="32"
          height="32"
          stroke="currentColor"
          stroke-width="2"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <div class="content-container">
        <div class="left-col">
          <h2 class="title">Příběh za Mapou</h2>
          <div class="image-placeholder"></div>
          <h3 class="name-label">Jméno a Příjmení</h3>
        </div>

        <div class="right-col">
          <p class="description">
            Anna Beata Háblová je architektka a spisovatelka, která dlouhodobě propojuje svět města
            a poezie. Ve své tvorbě se věnuje proměnám veřejného prostoru, vztahu lidí k místu i
            jemným vrstvám městské každodennosti. Je autorkou několika básnických sbírek, románů i
            odborných a popularizačních textů o architektuře a urbanismu. Aplikace Praha poetická je
            vytvořena ve spolupráci s Institutem plánování a rozvoje hl. m. Prahy a Praha město
            literatury.
          </p>
        </div>
      </div>

      <div class="footer-banner">
        <div class="logo-item">
          <div class="library-icon">
            <div class="box white-box"></div>
            <div class="box orange-box"></div>
            <div class="box empty-box"></div>
            <div class="box white-box"></div>
          </div>
          <div class="logo-text">
            <span>MĚSTSKÁ</span>
            <span>KNIHOVNA</span>
            <span>V PRAZE</span>
          </div>
        </div>

        <div class="prague-box">
          <span>PRA HA</span>
          <span>PRA GUE</span>
          <span>PRA GA</span>
          <span>PRA G</span>
        </div>

        <div class="ipr-logo">
          <div class="ipr-bold">IPR</div>
          <div class="ipr-line"></div>
          <div class="ipr-praha">PRAHA</div>
        </div>

        <div class="lit-box">
          <span>PRAHA</span>
          <span>MĚSTO</span>
          <span>LITERATURY</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&family=Newsreader:opsz,wght@6..72,400;6..72,500;6..72,700&display=swap');

.modal-backdrop {
  position: fixed;
  top: clamp(40px, 4.5vw, 50px);
  left: 0;
  width: 100vw;
  height: calc(100vh - clamp(40px, 4.5vw, 50px));
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
}

.modal-window {
  background-color: #fdfbf7;
  width: 90vw;
  max-width: 1100px;
  height: auto;
  max-height: 95%;
  border-radius: 4px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: #1a2432;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: #1a2432;
  cursor: pointer;
  z-index: 10;
  padding: 5px;
  transition: transform 0.2s ease;
}

.close-btn:hover {
  transform: scale(1.1);
}

.content-container {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  padding: 3rem 4rem 2rem 4rem;
  overflow: visible;
}

.left-col {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-family: 'Newsreader', serif;
  font-weight: 500;
  font-size: 2.2rem;
  margin: 0 0 1.5rem 0;
  width: 100%;
  text-align: left;
}

.image-placeholder {
  width: 75%;
  aspect-ratio: 4 / 5;
  background-color: #d9d9d9;
  margin-bottom: 1.5rem;
}

.name-label {
  font-family: 'Newsreader', serif;
  font-weight: 500;
  font-size: 1.5rem;
  margin: 0;
}

.right-col {
  padding-top: 4.5rem;
}

.description {
  font-family: 'Newsreader', serif;
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 1.6;
  text-align: justify;
  margin: 0;
}

.footer-banner {
  background-color: #f2a900;
  min-height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 3rem;
  font-family: 'Inter', sans-serif;
  margin-top: auto;
}

.logo-item {
  display: flex;
  align-items: center;
}

.library-icon {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.box {
  width: 100%;
  height: 100%;
}
.white-box {
  background-color: white;
}
.orange-box {
  background-color: #f2a900;
}
.empty-box {
  background-color: transparent;
}

.logo-text {
  display: flex;
  flex-direction: column;
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.1;
}

.prague-box {
  background-color: #1a2432;
  color: white;
  display: flex;
  flex-direction: column;
  padding: 8px;
  font-size: 0.6rem;
  font-weight: 400;
  letter-spacing: 2px;
  line-height: 1.2;
}

.ipr-logo {
  flex-direction: column;
  align-items: flex-start;
  color: #1a2432;
  position: relative;
}
.ipr-bold {
  font-size: 1.8rem;
  font-weight: 700;
  letter-spacing: 1px;
}
.ipr-line {
  position: absolute;
  top: 14px;
  left: 55px;
  width: 40px;
  height: 6px;
  background-color: #1a2432;
}
.ipr-praha {
  font-size: 1.5rem;
  font-weight: 400;
  margin-top: -5px;
}

.lit-box {
  background-color: #1a2432;
  color: #f2a900;
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.2;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 85%);
  padding-bottom: 20px;
}

@media (max-width: 768px) {
  .content-container {
    grid-template-columns: 1fr;
    padding: 2rem;
    gap: 1.5rem;
  }

  .right-col {
    padding-top: 0;
  }

  .footer-banner {
    flex-wrap: wrap;
    padding: 1rem;
    gap: 1rem;
    justify-content: center;
  }
}
.partner-logo {
  height: 48px;
  width: auto;
  object-fit: contain;
  display: block;
}
</style>
